import URI from 'urijs';
import IWindow from '@bingads-webui-clientcenter/window-interface';

export interface PifdTokenResponse {
  token: string | null;
}

export interface PifdTokenRequestOptions {
  url: string;
}

export interface PifdTokenThenable<TResult> {
  then<TNext>(
    onFulfilled: (value: TResult) => TNext | PromiseLike<TNext>
  ): PifdTokenThenable<TNext>;
  catch<TNext>(
    onRejected: (reason: unknown) => TNext | PromiseLike<TNext>
  ): PifdTokenThenable<TResult | TNext>;
}

export interface PifdAjaxPromise {
  get(options: PifdTokenRequestOptions): PifdTokenThenable<PifdTokenResponse>;
}

// eslint-disable-next-line func-names
export default function (ajaxPromise: PifdAjaxPromise, baseUrl = '/') {
  return ajaxPromise.get({ url: new URI(baseUrl).segment(['TokenExchange', 'PifdCommon']).href() })
    .then((response) => {
      if (response.token === null) {
        const currentUri = new URI(IWindow.location.href).hash('').normalizeHash();
        const logoutUri = new URI(currentUri.origin())
          .segment('logout')
          .addSearch({
            reason: 'MsaAadAuth',
            msg: 'sessionexpired', // resume MSA / AAD auth
            rurl: currentUri.href(),
          });
        IWindow.location.href = logoutUri.href();
      } else {
        response.token = `Bearer ${response.token}`;
      }
      return response;
    });
}
